module.exports = __webpack_public_path__ + "static/studio-2cebf84461d253a40fc99f92c247fdd4.jpg";